"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStringifiedFieldValueFromSchema = void 0;
var get_1 = __importDefault(require("lodash/get"));
var getStringifiedFieldValue_1 = require("./getStringifiedFieldValue");
var _1 = require(".");
function getStringifiedFieldValueFromSchema(propertyKey, schema, values) {
    var schemaPropertyKey = (0, _1.getNestedFieldNameSchemaProperty)(propertyKey);
    var schemaProperty = (0, get_1.default)(schema, schemaPropertyKey);
    var value = (0, _1.getFieldValue)(propertyKey, values);
    return (0, getStringifiedFieldValue_1.getStringifiedFieldValue)(value, schemaProperty);
}
exports.getStringifiedFieldValueFromSchema = getStringifiedFieldValueFromSchema;
